/**
 * Serialize a JSON-LD schema for embedding in
 * `<script type="application/ld+json">`.
 *
 * Escapes `<` so a `</script>` substring inside any string field can't break
 * out of the script tag and inject HTML. This matters because job postings
 * and other user-adjacent content may contain raw HTML (e.g., job.description).
 */
export function jsonLdSafe(schema: unknown): string {
  return JSON.stringify(schema).replace(/</g, "\\u003c");
}
